const ErrorPage = () => {
    return (
        <div style={{
            display: 'flex',
            width: '100%',
            height: '100vh',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <h4 className="mt-2">Ha ocurrido un error, no hemos encontrado su información</h4>
            <p>Contacte con soporte</p>
        </div>
    )
}

export default ErrorPage
